import { Theme } from '../interfaces/styled';

export const theme: Theme = {
  family: 'Handjet, sans-serif',
  colors: {
    text: '#FFFFFF',
    bg: '#000000',
  },
  fontSize: {
    header: 54,
  }
};
